/* Libraries */
import cn from 'classnames';
import Link from 'next/link';

/* Components */
import { Icon, Grid } from 'ht-styleguide';

/* Utils | Constants */
import { noop } from '@utils/event';
import { skuCatPath } from '@constants/paths';
import { SegmentTrackingAction } from '@integrations/segment/search';
import { categories } from '@components/Searchbar/constants';

/* Styles */
import styles from '../searchbar.module.scss';

/* Types */
type CategoryResultsProps = {
  iconClick: $FixMe;
  getItemProps?: $FixMe;
  searchTerm?: string;
  scoredResults: Array<any>;
};

const CategoryResults = ({ iconClick = noop, getItemProps, searchTerm }: CategoryResultsProps) => (
  <>
    <p className="caption marginTop-medium paddingBottom-tiny1 paddingX-small1 n700">CATEGORIES ({categories.length})</p>
    {categories.map((category, i) => {
      const onClick = () => {
        SegmentTrackingAction.search({
          searchTerm,
          clickedItem: 'category',
          attributes: {},
        });

        iconClick();
      };
      return (
        <div key={i} onClick={onClick}>
          <Grid.FullWidth classes={styles.categoryContainer}>
            <Grid.Row classes={styles.customRow}>
              <Link href={skuCatPath(category.category_seo_name.raw)} className={cn('paddingX-small1', styles.clickContainer)}>
                <Grid.Column classes={styles.columnContainer}>
                  <div className={styles.innerContainer}>
                    <Icon name={category.category_icon.raw} className={styles.icon} />
                    <div className={cn('h6 paddingLeft-small1', styles.name)}>{category.category_name.raw}</div>
                  </div>
                  <Icon name="chevron-right" className={styles.chevron} />
                </Grid.Column>
              </Link>
            </Grid.Row>
          </Grid.FullWidth>
        </div>
      );
    })}
  </>
);

export default CategoryResults;
